import { render, staticRenderFns } from "./home-tabs-text-item.vue?vue&type=template&id=0a9532d9&scoped=true&"
import script from "./home-tabs-text-item.vue?vue&type=script&lang=js&"
export * from "./home-tabs-text-item.vue?vue&type=script&lang=js&"
import style0 from "./home-tabs-text-item.vue?vue&type=style&index=0&id=0a9532d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9532d9",
  null
  
)

export default component.exports